
import UserDropDown from './UserDropDown';
function HeaderRightContent({profile}){
    return(
        <div className="d-flex align-item-center h-54px">
            <div className="d-flex h-30px align-item-center br-right me-3">
              {/* <i className="ri-translate-2 header-text font-size-18"></i> */}
              {/* <select className="header-select form-select pt-0 pb-0">
                <option>Eng</option>
                <option>Spa</option>
                <option>Ita</option>
              </select> */}
            </div>
            <div className="d-flex h-30px align-item-center br-right">
              {/* <i className="ri-moon-line header-text font-size-18 pe-3"></i>
              <i
                className="ri-notification-3-line header-text font-size-18 pe-3"
              ></i> */}
            </div>
            <UserDropDown profile = {profile}></UserDropDown>
          </div>
    )
}
 
export default HeaderRightContent;